import React, { useCallback, useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'

import { FiFile } from 'react-icons/fi'

import Yup from '~/services/yup'
import { api, authHeaders } from '~/services/api'

import { downloadRelatorioJasper } from '~/util/file'

import {
    Button, Select
} from '~/components/Form'
import Spinner from '~/components/Spinner'

import { Container, ButtonContainer } from './styles'

const initialValues = {
    ano: ''
}

const validation = Yup.object().shape({
    ano: Yup.string().ensure()
})

const nomeRelatorio = 'Ativos no Plano X Sem cobrança de Contribuição Social'

export default function (props) {
    const [anos, setAnos] = useState([])

    useEffect(() => {
        const currentYear = new Date().getFullYear()
        const listaAnos = []

        for (let i = currentYear; i > currentYear - 5; i--) {
            listaAnos.push({
                label: i,
                value: i
            })
        }

        setAnos(listaAnos)
    }, [])

    const handleSubmit = useCallback(async (values, { resetForm }) => {
        values.ano = values.ano.value

        try {
            const response = await api.post('relatorio', {
                relatorio: 'RelatorioAtivosPlanoSemContribuicao',
                parametros: {
                    ano: values.ano
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })

            downloadRelatorioJasper(response, nomeRelatorio)

            resetForm()
        } catch (e) {
            console.log(e)
            toast.error('Erro ao gerar o relatório.')
        }
    }, [])


    return (
        <Container className="animated fadeIn faster form" {...props}>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({
                    isSubmitting, setFieldValue, resetForm
                }) => (
                    <Form>
                        <h2>{nomeRelatorio}</h2>

                        <Select
                            name="ano"
                            label="Ano"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={anos}
                            containerStyle={{ gridArea: 'f1' }}
                        />

                        <Spinner
                            visible={isSubmitting}
                            label="Gerando relatório..."
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>

                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="white"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
